module.exports = __webpack_public_path__ + "img/vip.1ccc8dc8.png";